import React from 'react';
import { PhoneAuthenticationForm } from '@vette/ui-components';

export const SignupPage: React.FC = () => {
  return (
    <PhoneAuthenticationForm currentTab="signup" defaultRedirectPath="/terms" />
  );
};
